<template>
    <v-btn-toggle
        :value="alignValue"
        @change="alignChange"
        dense
    >
        <v-btn><v-icon>mdi-format-align-left</v-icon></v-btn>
        <v-btn><v-icon>mdi-format-align-center</v-icon></v-btn>
        <v-btn><v-icon>mdi-format-align-right</v-icon></v-btn>
    </v-btn-toggle>
</template>

<script>
const ALIGN_LEFT = 0
const ALIGN_CENTER = 1
const ALIGN_RIGHT = 2

export default {
    props: {
        editor: {
            type: Object,
        }
    },

    computed: {
        alignValue() {
            return this.isAlignActive('left') ? ALIGN_LEFT
                : this.isAlignActive('center') ? ALIGN_CENTER
                : this.isAlignActive('right') ? ALIGN_RIGHT
                : null
        },

        isAlignActive() {
            return (align) => this.editor ? this.editor.isActive({ textAlign: align }) : null
        }
    },

    methods: {
        setAlign(align) {
            this.editor
                .chain()
                .focus()
                .setTextAlign(align)
                .run()
        },

        alignChange(align) {
            let alignText = align == ALIGN_LEFT ? 'left'
                : align == ALIGN_CENTER ? 'center'
                : align == ALIGN_RIGHT ? 'right'
                : null

            if (! alignText) {
                return
            }

            this.setAlign(alignText)
        }
    },
}
</script>
